export default {
  bot: 'Bot',
  attendents: 'Atendentes',
  teams: 'Filas',
  tags: 'Etiquetas',
  closedTickets: 'Tickets finalizados',
  averageFirstResponseTime: 'Tiempo medio de la 1° respuesta',
  averageWaitTime: 'Tiempo medio de espera',
  averageResponseTime: 'Tiempo medio de respuesta',
  averageAttendanceTime: 'Tiempo medio de atención',
};
